export default "__VITE_ASSET__B9a4C$O3__"